var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 512C323.895 512 389.01 485.029 437.019 437.019C485.029 389.01 512 323.895 512 256C512 188.105 485.029 122.99 437.019 74.9807C389.01 26.9714 323.895 0 256 0C188.105 0 122.99 26.9714 74.9807 74.9807C26.9714 122.99 0 188.105 0 256C0 323.895 26.9714 389.01 74.9807 437.019C122.99 485.029 188.105 512 256 512ZM369 209L241 337C231.6 346.4 216.4 346.4 207.1 337L143.1 273C133.7 263.6 133.7 248.4 143.1 239.1C152.5 229.8 167.7 229.7 177 239.1L224 286.1L335 175C344.4 165.6 359.6 165.6 368.9 175C378.2 184.4 378.3 199.6 368.9 208.9L369 209Z",
    fill: "#4EAD8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckGreen);
export default __webpack_public_path__ + "static/media/circle-check-green.76e4adda1c98175445d45bc02b12a6a9.svg";
export { ForwardRef as ReactComponent };